import { getRenderStyleProperty } from '../../../../../../CanvasState/Helpers/Style/textBody';

const getAutoFitShape = shape => getRenderStyleProperty(shape, shape.get('textBody'), ['autoFitShape']);

export default getAutoFitShape;
